import Splide from '@splidejs/splide';

const NAV = '.js-ProcesCarouselNav';
const MEDIA = '.js-ProcesCarouselMedia';
const DATA = '.js-ProcesCarouselData';

// Find all sets of carousels
const navElements = document.querySelectorAll(NAV);

if (navElements.length > 0) {
  navElements.forEach((navElement) => {
    const carouselWrapper = navElement.closest('.proces');

    if (carouselWrapper) {
      const mediaElement = carouselWrapper.querySelector(MEDIA);
      const dataElement = carouselWrapper.querySelector(DATA);

      if (mediaElement && dataElement) {

        const SplideNav = new Splide(navElement, {
          autoWidth: true,
          arrows: false,
          pagination: false,
          drag: false,
          updateOnMove: true,
          isNavigation: true,
        });

        const SplideMedia = new Splide(mediaElement, {
          autoWidth: true,
          updateOnMove: true,
          pagination: false,
        });

        const SplideData = new Splide(dataElement, {
          arrows: false,
          pagination: false,
          updateOnMove: true,
          type: 'fade',
        });

        SplideMedia.on('move', function (newIndex, prevIndex, destIndex) {
          const counter = mediaElement.querySelector('.splide__counter span');

          if (counter) {
            counter.innerHTML = destIndex < 9 ? '0' + (destIndex + 1) : destIndex + 1;
          }
        });

        let updateHeight = (newIndex) => {
          const slide = SplideData.Components.Slides.getAt(
            typeof newIndex === 'number' ? newIndex : SplideData.index
          ).slide;
          slide.parentElement.parentElement.style.height = slide.offsetHeight + 'px';
        };

        SplideNav.sync(SplideMedia);
        SplideNav.sync(SplideData);

        SplideMedia.mount();
        SplideData.mount().on('move resize', updateHeight);
        SplideNav.mount();

        updateHeight();
      }
    }
  });
}
